export default "__VITE_ASSET__x9cs$BBW__"